module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-bar",
    attrs: {
      "id": "header-bar"
    }
  }, [_c('span', {
    staticClass: "header-bar_image",
    on: {
      "click": _vm.goHome
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "header-bar_links"
  }, [_c('button', {
    staticClass: "header-bar_link header-bar_button",
    attrs: {
      "name": "button"
    }
  }, [_vm._v("\n      Industries\n      "), _c('div', {
    staticClass: "header-bar_button-submenu"
  }, _vm._l((_vm.industries), function(industry) {
    return _c('a', {
      attrs: {
        "href": industry.link
      }
    }, [_vm._v(_vm._s(industry.title))])
  }), 0)]), _vm._v(" "), _c('button', {
    staticClass: "header-bar_link header-bar_button",
    attrs: {
      "name": "button"
    }
  }, [_vm._v("\n      Solutions\n      "), _c('div', {
    staticClass: "header-bar_button-submenu"
  }, _vm._l((_vm.solutions), function(solution) {
    return _c('a', {
      attrs: {
        "href": solution.link
      }
    }, [_vm._v(_vm._s(solution.title))])
  }), 0)]), _vm._v(" "), _c('a', {
    staticClass: "header-bar_link",
    attrs: {
      "href": "http://mikmak.tv#studios"
    },
    on: {
      "click": function($event) {
        return _vm.resetScroll('studios')
      }
    }
  }, [_vm._v("studios")]), _vm._v(" "), _c('a', {
    staticClass: "header-bar_link",
    attrs: {
      "href": "http://mikmak.tv#press"
    },
    on: {
      "click": function($event) {
        return _vm.resetScroll('press')
      }
    }
  }, [_vm._v("press")]), _vm._v(" "), _c('a', {
    staticClass: "header-bar_link header-bar_contact-link",
    attrs: {
      "href": "http://mikmak.tv#contact"
    },
    on: {
      "click": function($event) {
        return _vm.resetScroll('contact')
      }
    }
  }, [_vm._v("contact")])]), _vm._v(" "), _c('img', {
    staticClass: "mobile-logo",
    class: [_vm.mobileMenuVisible ? 'mobile-logo-visible' : 'mobile-logo-hidden'],
    attrs: {
      "src": require("../assets/mikmak-logo-white-new.png"),
      "alt": "mikmak"
    },
    on: {
      "click": _vm.goHome
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "header-toggle-mobile",
    on: {
      "click": _vm.toggleMobileMenu
    }
  }, [_c('label', {
    staticClass: "toggle-bar-top",
    class: [_vm.mobileMenuVisible ? 'top-tilt' : '']
  }), _vm._v(" "), _c('label', {
    staticClass: "toggle-bar-middle",
    class: [_vm.mobileMenuVisible ? 'middle-hidden' : '']
  }), _vm._v(" "), _c('label', {
    staticClass: "toggle-bar-bottom",
    class: [_vm.mobileMenuVisible ? 'bottom-tilt' : '']
  })]), _vm._v(" "), _c('span', {
    staticClass: "mobile-menu",
    class: [_vm.mobileMenuVisible ? 'visible' : 'hidden']
  }, [_c('button', {
    staticClass: "header-bar_link-mobile header-bar_button",
    attrs: {
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.showMobileIndustries = !_vm.showMobileIndustries
      }
    }
  }, [_vm._v("\n      Industries\n      "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMobileIndustries),
      expression: "showMobileIndustries"
    }],
    staticClass: "header-bar_button-mobile-submenu"
  }, _vm._l((_vm.industries), function(industry) {
    return _c('a', {
      attrs: {
        "href": industry.link
      }
    }, [_vm._v(_vm._s(industry.title))])
  }), 0)]), _vm._v(" "), _c('button', {
    staticClass: "header-bar_link-mobile header-bar_button",
    attrs: {
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.showMobileSolutions = !_vm.showMobileSolutions
      }
    }
  }, [_vm._v("\n      Solutions\n      "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMobileSolutions),
      expression: "showMobileSolutions"
    }],
    staticClass: "header-bar_button-mobile-submenu"
  }, _vm._l((_vm.solutions), function(solution) {
    return _c('a', {
      attrs: {
        "href": solution.link
      }
    }, [_vm._v(_vm._s(solution.title))])
  }), 0)]), _vm._v(" "), _c('a', {
    staticClass: "header-bar_link-mobile",
    attrs: {
      "href": "http://mikmak.tv#studios"
    },
    on: {
      "click": function($event) {
        return _vm.hideMobileMenu('studios')
      }
    }
  }, [_vm._v("studios")]), _vm._v(" "), _c('a', {
    staticClass: "header-bar_link-mobile",
    attrs: {
      "href": "http://mikmak.tv#press"
    },
    on: {
      "click": function($event) {
        return _vm.hideMobileMenu('press')
      }
    }
  }, [_vm._v("press")]), _vm._v(" "), _c('a', {
    staticClass: "header-bar_link-mobile",
    attrs: {
      "href": "http://mikmak.tv#contact"
    },
    on: {
      "click": function($event) {
        return _vm.hideMobileMenu('contact')
      }
    }
  }, [_vm._v("contact")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f70ee460"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/HeaderBar.vue
// module id = 507
// module chunks = 0